import React from 'react';
import { Outlet } from 'react-router-dom';
import './app-outlet.scss';

const AppOutlet = () => (
  <div className="app-outlet-slice">
    <Outlet />
  </div>
);

AppOutlet.propTypes = {
};

AppOutlet.defaultProps = {
};

export default AppOutlet;
